import React from 'react';
import { ImageBackground, TouchableOpacity } from 'react-native';
import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import analytics from '../../../modules/analytics';
import { useResponsiveEffect } from '../../../hooks';

import {
  Button, HeaderText, BodyText, Stack,
} from '../../ui';
import { sendPositiveRating, sendNegativeRating } from '../../../modules/rateThisApp';
import { CloseIcon } from '../../ui/Icons';

import BackgroundImage from '../images/group_on_khaki_bg.png';

export const RateThisApp = ({
  onPositiveClick,
  onNegativeClick,
  onClose,
}: {
  onPositiveClick?: () => void;
  onNegativeClick?: () => void;
  onClose: () => void;
}) => {
  const is = useResponsiveEffect();

  /**
   * Handles click of the button indicating happy users.
   */
  const handlePositiveClick = () => {
    sendPositiveRating();

    if (typeof onPositiveClick === 'function') {
      onPositiveClick();
    }
  };

  /**
   * Handles click of the button indicating unhappy users.
   */
  const handleNegativeClick = () => {
    sendNegativeRating();

    if (typeof onNegativeClick === 'function') {
      onNegativeClick();
    }
  };

  const handleClose = () => {
    analytics.track('client_apprating_close_click');
    onClose();
  };

  return (
    <Stack testID="rate-this-app-component">
      <ImageBackground source={BackgroundImage}>
        <Box
          flexDirection="row-reverse"
          paddingTop={16}
          paddingRight={8}
          minHeight={is.desktop ? 200 : 156}
        >
          <TouchableOpacity onPress={handleClose}>
            <CloseIcon color={colors.blackInBlack} width={24} height={24} />
          </TouchableOpacity>
        </Box>
      </ImageBackground>
      <Stack padding={32} space={32}>
        <Stack space={8}>
          <HeaderText fontSize={32} lineHeight={46} textAlign={is.desktop ? 'center' : 'left'}>
            How was your booking?
          </HeaderText>
          <BodyText appearance="large" color={colors.metal} textAlign={is.desktop ? 'center' : 'left'}>
            Let us know how we&apos;re doing!
          </BodyText>
        </Stack>
        <Stack space={16}>
          <Button
            appearance="primary-neue"
            size="large"
            onClick={handlePositiveClick}
            clickTracking="client_apprating_positive_click"
          >
            It Was Great!
          </Button>
          <Button
            appearance="link-lowercase"
            size="large"
            onClick={handleNegativeClick}
            clickTracking="client_apprating_negative_click"
          >
            I Had A Problem
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
